export default "https://cdn-static.gokick.com/assets/5a032fdfc840f3d1fce44ec205c52ed2ca8e0677/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";